import type { Device } from '@studio/models/device';
import { DeviceRegistryCommandKey } from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { locateProxy } from '#~/agent/index.js';

/** @internal */
export const power = async (deviceId: Device['id'], onOrOff: boolean): Promise<void> => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    throw new Error('PW-79B');
  }

  return proxy.mutate(
    {
      control: {
        device: {
          [deviceId]: {
            deviceSettings: {
              [DeviceRegistryCommandKey.POWER]: {
                toggle: onOrOff
              }
            }
          }
        }
      }
    },
    {}
  );
};
